import { render } from "./header-setting.html?vue&type=template&id=42214a2a&scoped=true&ts=true"
import script from "./header-setting.ts?vue&type=script&lang=ts"
export * from "./header-setting.ts?vue&type=script&lang=ts"

import "./header-setting.scss?vue&type=style&index=0&id=42214a2a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42214a2a"]])

export default __exports__